module.exports = "\n<div #gmap style=\"width:100%;height:100%; position: absolute\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/bus/parent/bus-attendance/student-location/StudentLocationComponent.html
// module id = 751
// module chunks = 0